import { Card, Col, Row } from 'antd';
import PriceChoices from 'components/Pricing/PriceChoices';
import { HitchGoLive } from 'components/public/integrations/useHitchConfiguration';
import React from 'react';
import { Hike } from 'services/hitchit/types/hike/Hike';

const GoLive = ({ hike, hitchGoLive }: { hike?: Hike; hitchGoLive: HitchGoLive }): JSX.Element => {
  return (
    <Row justify="center" gutter={[32, 32]} style={{ textAlign: 'left' }}>
      <Col xl={18} md={24}>
        <Card bordered>
          {hike ? <PriceChoices hike={hike} hitchGoLive={hitchGoLive} /> : undefined}
        </Card>
      </Col>
    </Row>
  );
};
export default GoLive;
